export const isMobile = window.innerWidth <= 800;
